import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import SnackBar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DeleteIcon from "@material-ui/icons/Delete";

import { useStyles } from "../../../../../Components/CSS/FormStyle.css";
import CustomDialogBox from "../../../../../Components/CustomDialogBox/CustomDialogBox";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";

class ExamBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dialogOpen: false,
      notificationOpen: false,
      examId: "",
      editStatus: false,
      data: {
        name: "",
      },
      loading: false,
      examTypeError: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      data: {
        name: e.target.value,
      },
    });
  };

  handleDialogOpen = (examId) => {
    this.setState({
      dialogOpen: true,
      examId,
    });
  };

  handleDialogClose = () => {
    this.setState({
      dialogOpen: false,
    });
  };

  handleNotificationOpen = () => {
    this.setState({
      notificationOpen: true,
    });
  };

  handleNotificationClose = () => {
    this.setState({
      notificationOpen: false,
    });
  };

  showNotification = () => {
    return (
      <SnackBar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={this.state.notificationOpen}
        onClose={this.handleNotificationClose}
        autoHideDuration={1600}
        style={{ top: 80, right: 10 }}
      >
        <MuiAlert
          onClose={this.handleNotificationClose}
          severity="error"
          elevation={6}
          variant="filled"
        >
          Deleted Successfully
        </MuiAlert>
      </SnackBar>
    );
  };

  handleEditExam = async (examId) => {
    this.setState({
      editStatus: true,
    });
    try {
      const response = await Axios.get(`${url}/api/exam-types/${examId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.examType.length !== 0) {
        this.setState({
          examId,
          data: { name: response.data.examType.name },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleEditExam(examId);
      }
    }
  };

  handleCancelEdit = () => {
    this.setState({
      editStatus: false,
    });
  };

  handleDeleteExam = async () => {
    try {
      const response = await Axios.delete(
        `${url}/api/exam-types/${this.state.examId}`,
        {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        }
      );
      console.log(response.data);
      if (response.data.message === "Exam Type deleted successfully") {
        this.handleDialogClose();
        this.handleNotificationOpen();
        this.props.getExams();
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleDeleteExam();
      }
    }
  };

  checkError = (examType) => {
    let examTypeError = examType ? examType : "";
    if (examTypeError) {
      this.setState({ examTypeError });
      return true;
    } else {
      this.setState({ examTypeError: "" });
      return false;
    }
  };

  handleEditSubmit = async (e) => {
    e.preventDefault();
    let errorStatus = this.checkError();
    if (errorStatus === false) {
      try {
        const response = await Axios.put(
          `${url}/api/exam-types/${this.state.examId}`,
          this.state.data,
          {
            headers: {
              Authorization: `Bearer ${this.props.adminToken}`,
            },
          }
        );
        if (response.data.message === "Exam Type updated successfully") {
          this.handleCancelEdit();
          this.props.getExams();
        }
      } catch (error) {
        if (
          error.response.data.message ===
          "Exam type with given name already in database"
        ) {
          console.clear();
          this.checkError("Exam Type already registered");
        }
        if (
          error.response.data === "jwt expired" &&
          error.response.status === 401
        ) {
          console.clear();
          let refreshToken = { refreshToken: this.props.refreshToken };
          this.props.getAdminRefreshToken(refreshToken, this.props.role);
          this.handleEditSubmit(e);
        }
      }
    }
  };

  render() {
    const { classes, data, index } = this.props;
    return this.state.editStatus === false ? (
      <TableRow
        style={{
          backgroundColor: `${index % 2 ? "#fff" : "#eee"}`,
        }}
      >
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">{data.name}</TableCell>

        <TableCell align="center">
          <Tooltip
            title="Edit"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleEditExam(data._id)}
          >
            <EditIcon />
          </Tooltip>
          <Tooltip
            title="Delete"
            arrow
            className={classes.tooltip}
            onClick={() => this.handleDialogOpen(data._id)}
          >
            <DeleteIcon />
          </Tooltip>
          {this.showNotification()}
        </TableCell>
        <CustomDialogBox
          open={this.state.dialogOpen}
          handleClose={this.handleDialogClose}
          handleDelete={this.handleDeleteExam}
        />
      </TableRow>
    ) : (
      <TableRow>
        <TableCell />
        <TableCell align="center">
          <TextField
            name="name"
            type="text"
            label="Subject Name"
            required
            fullWidth
            variant="outlined"
            margin="normal"
            error={this.state.examTypeError ? true : false}
            helperText={this.state.examTypeError}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={this.state.data.name}
            onChange={this.handleChange}
          />
        </TableCell>
        <TableCell align="center">
          <Tooltip
            title="Update"
            arrow
            onClick={this.handleEditSubmit}
            className={classes.tooltip}
          >
            <CheckCircleIcon />
          </Tooltip>
          <Tooltip
            title="Cancel"
            arrow
            onClick={this.handleCancelEdit}
            className={classes.tooltip}
          >
            <CancelIcon />
          </Tooltip>
          <br />
          {this.state.loading && <FormLoader />}
        </TableCell>
      </TableRow>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ExamBody)));
